export const extractTime = (dateString) => {
    try {
        // Check if the string is already in HH:mm format
        if (/^\d{2}:\d{2}$/.test(dateString)) {
            return dateString; // Return as-is if it's already in HH:mm format
        }

        // Parse the date string into a Date object
        const date = new Date(dateString);

        // Extract hours and minutes
        const hours = String(date.getHours()).padStart(2, '0'); // Ensure 2-digit hours
        const minutes = String(date.getMinutes()).padStart(2, '0'); // Ensure 2-digit minutes

        return `${hours}:${minutes}`; // Return in HH:mm format
    } catch (error) {
        console.error('Invalid date format:', dateString);
        return ''; // Fallback to an empty string if parsing fails
    }
};

export const formatTime = (timeString) => {
    if (!timeString) return '';
    if (timeString === "null") return '';
    let dateObj;

    // Check if the timeString contains "T", indicating ISO 8601 format
    if (timeString.includes('T')) {
        dateObj = new Date(timeString);
    } else {
        // Assuming the time is in "HH:mm" format, we create a new Date object for today with this time.
        const [hours, minutes] = timeString.split(':');
        dateObj = new Date();
        dateObj.setHours(hours);
        dateObj.setMinutes(minutes);
        dateObj.setSeconds(0);
    }

    // Format the time using toLocaleTimeString() to display in AM/PM format
    return dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
};